<template>
  <div class="flex flex-col">
    <button
      class="warning-button ml-auto mr-4"
      @click="updateSyncStates()"
      v-if="!loading"
    >
      Sync States
    </button>
    <BaseSmallSpinner v-if="loading"></BaseSmallSpinner>
    <template v-else>
      <div id="selection">
        <div
          class="
            flex
            flex-row
            justify-center
            items-center
            bg-white
            border
            border-gray-300
            p-2
            text-center
            m-2
            rounded-md
            hover:bg-gray-300
            hover:text-white
            w-72
          "
          v-if="selectedState !== ''"
        >
          {{ selectedState }} - {{ selectedStateCode }}
          <button
            @click="deselectState"
            class="bg-black rounded-full overflow-hidden text-white w-6 h-6 ml-4 flex justify-center items-center font-bold"
          >
            x
          </button>
        </div>
      </div>
      <div id="states" class="w-72 p-4" v-if="selectedState == ''">
        <h1 class="my-2">State Name</h1>
        <input
          class="border border-gray-300 rounded-md w-full p-2 mb-4"
          placeholder="filter state"
          v-model="stateSearch"
        />
        <div
          class="
            w-full
            bg-white
            border
            border-gray-300
            p-2
            text-center
            rounded-md
            my-2
            hover:bg-gray-300
            hover:text-white
          "
          v-for="state in filteredStates"
          :key="state.id"
          @click="selectState(state)"
        >
          <h1>{{ state.stateName }} - {{ state.stateCode }}</h1>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { getStates, getSyncStates } from "@/api/Infoauto.js";
export default {
  name: "States",
  data() {
    return {
      states: [],
      loading: true,
      stateSearch: "",
      selectedState: "",
      selectedStateCode: ""
    };
  },
  props: {
    country: {
      type: String,
      required: true
    }
  },
  async mounted() {
    try {
      this.states = await getStates(this.country);
    } catch (e) {
      console.log(e);
    }
    this.loading = false;
  },
  computed: {
    filteredStates() {
      return this.states.filter(state => {
        return state.stateName
          .toLowerCase()
          .includes(this.stateSearch.toLowerCase());
      });
    }
  },
  methods: {
    async updateSyncStates() {
      this.loading = true;
      try {
        this.states = await getSyncStates();
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
    selectState(state) {
      this.$emit("selectedState", state.stateName);
      this.selectedState = state.stateName;
      this.selectedStateCode = state.stateCode;
    },
    deselectState() {
      this.selectedState = "";
      this.selectedStateCode = "";
      this.$emit("deselectedState");
    }
  }
};
</script>
